'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaHtml5 = function FaHtml5(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm29.7 13.3l0.4-3.9h-19.8l1.1 11.9h13.7l-0.5 5.1-4.4 1.2-4.4-1.2-0.3-3.1h-3.9l0.5 6.2 8.1 2.2h0.1v0l8-2.2 1.1-12.1h-14.4l-0.3-4.1h15z m-25.2-10.4h31.4l-2.8 32.1-12.9 3.6-12.8-3.6z' })
        )
    );
};

exports.default = FaHtml5;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/fa/html5.js
// module id = 1544
// module chunks = 0